import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import Page from '~/components/page/page';
import Icon from '~/components/icon/icon';

export class NotFoundPage extends Component {
  render() {
    const { loggedIn, history } = this.props;
    if (!loggedIn) {
      // There's a weird issue with the redirect to login stuff here. If you go to a page and you aren't logged in, we get
      // redirected back to the login page with the redirect url after that as a query param. Weirdly that URL is fine if
      // you hit it directly but when it's used as part of the redirect the not-found page shows. So in that case we want to
      // login but keep the query params.
      const currentUrl = this.props.location.pathname;
      let redirectUrl = currentUrl.startsWith('/login') ? currentUrl : '/login';
      return <Redirect to={redirectUrl} />;
    }

    return (
      <Page>
        <section className="tc">
          <Icon icon="cat-lost" className="pt4 pb5" />
          <h3>Sorry, this page doesn't seem to exist</h3>
          <Button className="mt5" color="primary" onClick={() => history.goBack()}>
            Go back
          </Button>
        </section>
      </Page>
    );
  }
}

export default connect(state => ({
  loggedIn: state.auth.loggedIn
}))(withRouter(NotFoundPage));



// WEBPACK FOOTER //
// ./src/pages/notFound/notFound.jsx